export default (function (_ref) {
  var request = _ref.request;
  return {
    breedFeedMethodAdd: function breedFeedMethodAdd(data) {
      return request({
        url: '/cms/breedFeedMethod/add',
        method: 'post',
        data: data
      });
    },
    breedFeedMethodModify: function breedFeedMethodModify(data) {
      return request({
        url: "/cms/breedFeedMethod/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    breedFeedMethodDel: function breedFeedMethodDel(id) {
      return request({
        url: "/cms/breedFeedMethod/".concat(id, "/del"),
        method: 'delete'
      });
    },
    breedFeedMethodQuery: function breedFeedMethodQuery(data) {
      return request({
        url: '/cms/breedFeedMethod',
        method: 'get',
        params: data
      });
    },
    breedFeedMethodDetail: function breedFeedMethodDetail(id) {
      return request({
        url: "/cms/breedFeedMethod/".concat(id),
        method: 'get'
      });
    }
  };
});